"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  MISSING_SRC: true,
  SCRIPT_ERROR: true,
  NOT_IN_BROWSER: true,
  applyScript: true,
  toBase64: true,
  convertBooleanToNumber: true
};
exports.toBase64 = exports.convertBooleanToNumber = exports.applyScript = exports.SCRIPT_ERROR = exports.NOT_IN_BROWSER = exports.MISSING_SRC = void 0;
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});
var _file = require("./file");
Object.keys(_file).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _file[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _file[key];
    }
  });
});
var _calendar = require("./calendar");
Object.keys(_calendar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _calendar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calendar[key];
    }
  });
});
var MISSING_SRC = exports.MISSING_SRC = 'Should specify a source for script element';
var SCRIPT_ERROR = exports.SCRIPT_ERROR = 'Error occured in loading this script';
var NOT_IN_BROWSER = exports.NOT_IN_BROWSER = 'Should use this function in web-application';

/**
 * Function to apply js script to body
 *
 * @public
 * @param {string} src - URL for the js script
 * @returns {Promise<void>}
 */
var applyScript = exports.applyScript = function applyScript(src) {
  return new Promise(function (resolve, reject) {
    if ((0, _isNil["default"])(src)) {
      return reject(MISSING_SRC);
    }
    var isExist = document.querySelector("script[src=\"".concat(src, "\"]"));
    if ((0, _isNil["default"])(isExist)) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.addEventListener('load', function () {
        resolve();
      });
      script.addEventListener('error', function () {
        reject(SCRIPT_ERROR);
      });
      if (!(0, _isNil["default"])(document.body)) {
        document.body.appendChild(script);
      } else reject(NOT_IN_BROWSER);
    } else resolve();
  });
};
var toBase64 = exports.toBase64 = function toBase64(input) {
  if ((0, _isEmpty["default"])(input)) return null;else return btoa(JSON.stringify(input));
};
var convertBooleanToNumber = exports.convertBooleanToNumber = function convertBooleanToNumber(query) {
  var ret = {};
  Object.keys(query).forEach(function (key) {
    if (query[key] === true) {
      ret[key] = 1;
    } else if (query[key] === false) {
      ret[key] = 0;
    } else {
      ret[key] = query[key];
    }
  });
  return ret;
};
//# sourceMappingURL=index.js.map